import { Briefcase, Users, Award, Target } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const About = ({ personalInfo }) => {
  const stats = [
    {
      icon: Users,
      value: '600+',
      label: 'Students Mentored',
      color: '#9A7B4F'
    },
    {
      icon: Briefcase,
      value: '7+',
      label: 'Internships Completed',
      color: '#C4A76C'
    },
    {
      icon: Award,
      value: '1,500+',
      label: 'Event Attendees',
      color: '#9A7B4F'
    },
    {
      icon: Target,
      value: '7+',
      label: 'Years of Service',
      color: '#C4A76C'
    }
  ];

  return (
    <section id="about" className="py-20 bg-[#0D1117]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            About Devansh Gupta
          </h2>
          <p className="text-lg text-white/70 max-w-3xl mx-auto">
            Finance student, business consultant, and social impact leader making a difference in education and communities
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <Card key={index} className="border-white/10 bg-white/5 backdrop-blur-sm shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1">
                <CardContent className="p-6 text-center">
                  <Icon className="mx-auto mb-3" size={32} style={{ color: stat.color }} />
                  <div className="text-3xl font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-sm text-white/60">{stat.label}</div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bio Content */}
        <div className="max-w-4xl mx-auto">
          <Card className="border-white/10 bg-white/5 backdrop-blur-sm shadow-2xl">
            <CardContent className="p-8 md:p-12">
              <div className="prose prose-lg max-w-none">
                <p className="text-white/70 leading-relaxed mb-6">
                  Hello! I'm <strong className="text-white">Devansh Gupta</strong>, currently pursuing a Bachelor in <strong className="text-white">International Economics & Management</strong> at <strong className="text-white">Università Bocconi, Milan</strong>. With a strong foundation in finance, accounting, and economics, I'm passionate about analyzing markets and driving business growth through strategic financial insights.
                </p>
                <p className="text-white/70 leading-relaxed mb-6">
                  My journey in finance has taken me through internships at <strong className="text-white">Housy S.r.l.</strong> working on strategic market development, <strong className="text-white">Magnum Finvest Services</strong> analyzing equity funds, and business consultancy roles optimizing profitability strategies. I combine analytical rigor with practical business acumen.
                </p>
                <p className="text-white/70 leading-relaxed">
                  Beyond finance, I'm deeply committed to social impact. I currently lead a group of <strong className="text-[#9A7B4F]">600+ freshmen</strong> navigating the complex college application process, making it simpler and more accessible. Working in direct collaboration with the Head of International Recruitment at Bocconi, I bridge the gap between aspiring students and their dream institutions.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;